import React from "react";
import Counter from "../Counter";

function App() {
  return (
    <>
      {/* <header>
        <h1>Counter</h1>
     </header>*/}
      <main>
        <Counter />
      </main>
    </>
  );
}

export default App;
